import { useMemo } from "react";

export const useUserResources = (user, activeWineryId) => {
  return useMemo(() => {
    const permissions = user?.activeWineryPermissions || {};
    // console.log('🎯 useUserResources:', {
    //   hasUser: !!user,
    //   hasActiveWineryPermissions: !!user?.activeWineryPermissions,
    //   permissionsKeys: Object.keys(permissions),
    //   fullPermissions: permissions
    // });
    return permissions;
  }, [user?.activeWineryPermissions]);
};
